// harmony-cart-upsells.js — Embla carousel for the cart-drawer upsell row.
// The drawer's DOM is re-rendered on every cart change, so a MutationObserver
// re-initialises whenever a fresh [data-h-upsells] node appears.
// Also purges Recharge subscription widgets injected into upsell
// product-forms — upsells are one-time purchase only (same neuter contract
// as the PDP: hide the widget, disable/remove its fields so nothing posts
// a selling_plan).
(function () {
  if (window.__hCartUpsellsInit) return;
  window.__hCartUpsellsInit = true;

  const init = (root) => {
    if (root._hEmbla || typeof window.EmblaCarousel !== 'function') return;
    const viewport = root.querySelector('[data-h-upsells-viewport]');
    if (!viewport) return;
    const embla = window.EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
    });
    root._hEmbla = embla;
    root.querySelector('[data-h-upsells-prev]')?.addEventListener('click', () => embla.scrollPrev());
    root.querySelector('[data-h-upsells-next]')?.addEventListener('click', () => embla.scrollNext());
  };

  const purgeRc = () => {
    document
      .querySelectorAll('cart-drawer .rc-container-wrapper, cart-drawer .rc_widget, cart-drawer .rc-selling-plans')
      .forEach((widget) => {
        const top = widget.closest('.rc-container-wrapper') || widget;
        top.style.display = 'none';
        top.setAttribute('aria-hidden', 'true');
        top.querySelectorAll('input, select, button, textarea').forEach((f) => {
          f.disabled = true;
        });
      });
    /* A bare selling_plan field can also be injected straight into an
       upsell form — remove it so the add always posts one-time purchase. */
    document.querySelectorAll('[data-h-upsells] form [name="selling_plan"]').forEach((f) => f.remove());
  };

  /* Last line of defence: if a subscription script appends a selling_plan
     at submit time (after the DOM purge ran), strip it while the FormData
     is being built — formdata fires during `new FormData(form)`, after all
     submit handlers. */
  document.addEventListener('formdata', (e) => {
    if (e.target.closest?.('[data-h-upsells]')) e.formData.delete('selling_plan');
  });

  const scan = () => {
    purgeRc();
    if (typeof window.EmblaCarousel !== 'function') return;
    document.querySelectorAll('[data-h-upsells]').forEach(init);
  };

  const boot = () => {
    scan();
    const host = document.querySelector('cart-drawer');
    if (host) new MutationObserver(scan).observe(host, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
